import React, { useState, useRef } from 'react';
import Select from 'react-select';
import { gql, useMutation } from '@apollo/client';
import { FaClipboard, FaCheck } from 'react-icons/fa'; // Importing icons for copy functionality
import { useOnClickOutside } from 'usehooks-ts'; // Import useClickAway
import './ShareTripLink.scss'; // Assuming you want to add custom styles
import { ErrorToast, SuccessToast } from '../../../../ToastComponent/RectHotToast';

const GET_SHARABLE_URL = gql`
  mutation GenerateSharableURL($generateSharableUrlId: ID!, $timeInHrs: String) {
    GenerateSharableURL(id: $generateSharableUrlId, timeInHRS: $timeInHrs) {
      URL
    }
  }
`;

const ShareTripLink = ({ tripId, setShowShareLink }) => {
  const [linkLiveDuration, setLinkLiveDuration] = useState({ value: '1 Hour', label: '1 Hour' });
  const [url, setUrl] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const [getSharableLink, { loading: getSharableLinkLoading, data: getSharableLinkData, error: getSharableLinkError }] =
    useMutation(GET_SHARABLE_URL, {
      context: {
        headers: { "X-GraphQL-Server": "location" },
      },
      fetchPolicy: "network-only",
      onError: (error) => {
        ErrorToast(error.message);
      },
      onCompleted: (data) => {
        const Url = data.GenerateSharableURL?.URL;
        setUrl(Url);
        copyToClipboard(Url); // Automatically copy the URL on success
        SuccessToast("URL is Copied to Clipboard");
      },
    });

  const options = [
    { value: '1 Hour', label: '1 Hour' },
    { value: '2 Hours', label: '2 Hours' },
    { value: '6 Hours', label: '6 Hours' },
    { value: '12 Hours', label: '12 Hours' },
    { value: '24 Hours', label: '24 Hours' },
    { value: 'Till Delivery', label: 'Till Delivery' },
  ];

  const handleShareLink = () => {
    getSharableLink({
      variables: {
        generateSharableUrlId: tripId,
        timeInHrs: linkLiveDuration.value,
      },
    });
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000); // Reset copied state after 2 seconds
  };

  // Create a ref for the share link container
  const shareLinkRef = useRef(null);

  // Use the useClickAway hook to detect outside clicks
  useOnClickOutside(shareLinkRef, () => {
    setShowShareLink(false); // Hide the component when clicked outside
  });

  return (
    <div ref={shareLinkRef} className="share-trip-link__container"> {/* Attach ref here */}
      <h2>Select tracking link live duration</h2>
      <Select
        options={options}
        value={linkLiveDuration}
        onChange={setLinkLiveDuration}
        className="share-trip-link__select"
        placeholder="Select Duration"
      />
      <button
        onClick={handleShareLink}
        className="share-trip-link__button"
        disabled={getSharableLinkLoading}
      >
        {getSharableLinkLoading ? 'Generating Link...' : 'Share Tracking Link'}
      </button>

      {/* Display generated URL */}
      {url && (
        <div className="share-trip-link__result">
          <div className="share-trip-link__url-box">
            <input
              type="text"
              value={url}
              readOnly
              className="share-trip-link__url-input"
            />
            <button
              className="share-trip-link__copy-button"
              onClick={() => copyToClipboard(url)}
            >
              {isCopied ? <FaCheck /> : <FaClipboard />}
            </button>
          </div>
          {isCopied && <p className="share-trip-link__copied-text">Copied!</p>}
        </div>
      )}

      {getSharableLinkError && <p className="error">Error generating link. Please try again.</p>}
    </div>
  );
};

export default ShareTripLink;
